export var ProductBasedCollectionState;
(function (ProductBasedCollectionState) {
    ProductBasedCollectionState["PRODUCT_BASED_COLLECTION_STATE_UNKNOWN"] = "PRODUCT_BASED_COLLECTION_STATE_UNKNOWN";
    /**
     * Collections that are not published and potentially invalid
     */
    ProductBasedCollectionState["DRAFT"] = "DRAFT";
    /**
     * Collections that are active and visible to retailers. They must be valid.
     */
    ProductBasedCollectionState["PUBLISHED"] = "PUBLISHED";
    /**
     * Collections that have been archived. May be set to a draft or published state again
     */
    ProductBasedCollectionState["ARCHIVED"] = "ARCHIVED";
    /**
     * Collections that are permanently deleted and no longer visible to the brand
     */
    ProductBasedCollectionState["DELETED"] = "DELETED";
})(ProductBasedCollectionState || (ProductBasedCollectionState = {}));
